import { message, Modal } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";

import { useNavigate } from "react-router-dom";
import {
  deleteRanking,
  rankingsChangeModalState,
  refreshTableRankings,
  setIsRankingsForUpdate,
  setRankingsForUpdate,
} from "../../../redux";
import useAppDispatch from "../../../redux/hooks/useAppDispatch";
import { useRankings } from "./useRankings";
import { DataIRankings } from "../../../redux/@types";

const { confirm } = Modal;

export const useTableRankings = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { tableProps } = useRankings();

  const changeRankingsForUpdate = (rank: DataIRankings) => {
    dispatch(setIsRankingsForUpdate(true));
    dispatch(setRankingsForUpdate(rank));
    dispatch(rankingsChangeModalState());
  };

  const showDeleteConfirm = (valId: number, val: string) => {
    confirm({
      title: `Estás seguro de borrar la calificación con el id: ${valId}`,
      icon: <ExclamationCircleOutlined />,
      content: `Una vez ejecutada esta acción no hay vuelta atrás, estás por borrar a "${val}", si deseas continuar dale click a "Borrar calificación" en caso tal solo oprime en "
              Cancelar".`,
      okText: "Borrar calificación",
      okType: "danger",
      cancelText: "Cancelar",
      keyboard: true,
      maskClosable: true,
      async onOk() {
        await deleteRanking(valId)
          .then(() => {
            dispatch(refreshTableRankings(true));
            message.success(`Se ha borrado la calificación con id:${valId}`);
            tableProps?.refresh();
          })
          .catch((err) => {
            console.log({ err });
            message.error(err.message);
          });
      },
      onCancel() {},
    });
  };

  return {
    //state
    //methods
    //functions
    changeRankingsForUpdate,
    showDeleteConfirm,
  };
};
